export default __webpack_public_path__ + "static/media/phi.af2533fc.png";